import React, { FC } from 'react';
import { Typography } from '@material-ui/core';
import { Raffle } from '../../../../lib/types';
interface ParticipantsProps {
  raffle: Raffle;
}

const index: FC<ParticipantsProps> = ({ raffle }) => {
  //   console.log(Array.from(raffle.entrants.values()), 'raff');
  return (
    <div className="w-full py-6">
      {raffle.entrants.size > 0 ? (
        <div className=" h-24 bg-red- overflow-y-scroll hide-scrollbar ">
          {Array.from(raffle.entrants.values())
            .sort((a, b) => b.tickets.length - a.tickets.length)
            .map((item: any) => (
              <div
                key={item.publicKey.toBase58()}
                className=" flex items-center justify-between pr-4"
              >
                <p className="text-brand_secondary text-xs pr-3">
                  {item.publicKey.toBase58()}
                </p>
                <p className="text-brand_secondary text-xs">{item.tickets.length}</p>
              </div>
            ))}
        </div>
      ) : (
        <div className="text-white text-sm">
          <p>Be the first one to join this raffle!</p>
        </div>
      )}
    </div>
  );
};

export default index;
